import React, { useState, useEffect } from "react";
import { phappsRequest } from "@/services/apiService";
import { API_PATHS } from "@/config/apiConstants";
import { DataGrid } from "@mui/x-data-grid";

const ChemistListModal = ({ isOpen, onClose }) => {
  const [chemists, setChemists] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (isOpen) {
      fetchChemists();
    }
  }, [isOpen]);

  const fetchChemists = async () => {
    setIsFetching(true);
    setStatus(null);
    try {
      const response = await phappsRequest(API_PATHS.CHEMIST_LIST, "GET");
      if (response.success && Array.isArray(response.chemists)) {
        setChemists(response.chemists);
      } else {
        setStatus({ type: "error", message: "Failed to load chemists list" });
      }
    } catch (error) {
      console.error(error);
      setStatus({ type: "error", message: "Error loading chemists" });
    } finally {
      setIsFetching(false);
    }
  };

  if (!isOpen) return null;

  const columns = [
    { field: "chemistID", headerName: "ID", width: 70 },
    { field: "chemistName", headerName: "Name", width: 250, flex: 1 },
    { field: "PHUUID", headerName: "PHUUID", width: 300 },
    { field: "userName", headerName: "Username", width: 150 },
    { field: "phone", headerName: "Phone", width: 130 },
    { field: "TAC", headerName: "TAC", width: 100 },
  ];

  const rows = chemists.map((c) => ({
    id: c.chemistID || c.PHUUID,
    ...c,
  }));

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
      <div className="bg-white rounded-lg p-6 w-full max-w-5xl mx-4 my-8 h-[80vh] flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Chemist List</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {status && (
          <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
            {status.message}
          </div>
        )}

        <div className="flex-1 min-h-0 w-full">
            <DataGrid
              rows={rows}
              columns={columns}
              loading={isFetching}
              disableRowSelectionOnClick
            />
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChemistListModal;

